





































import { defineComponent, ref, provide, useContext } from "@nuxtjs/composition-api";
import { useGtm } from "~/composables";
import { getLocalizedPath, isExternalUrl } from "~/helpers/getLocalizedPath";
import MenuItemSub from "./MenuItemSub.vue";

export default defineComponent({
  name: "MenuItem",
  components: {
    MenuItemSub,
  },
  props: {
    menu: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup() {
    const { app: { i18n } } = useContext();
    const { eventCustomlinksInteracted } = useGtm();
    const onMouseEnter = () => (isOpen.value = true);
    const onMouseLeave = () => (isOpen.value = false);
    const isOpen = ref(false);
    const closeNav = (value) => {
      isOpen.value = value;
    };
    provide('isOpen', {isOpen, closeNav});
    const navigationTracking = (menu) => {
      eventCustomlinksInteracted({
        "eventlabel": menu.title,
        "eventCategory": "Primary Navigation Links",
      });
    };
    const getMenuLink = (urlKey) => getLocalizedPath(urlKey, i18n);

    return {
      isOpen,
      onMouseEnter,
      onMouseLeave,
      closeNav,
      navigationTracking,
      getMenuLink,
      isExternalUrl,
    };
  },
});
